import { render, staticRenderFns } from "./TemuOpportunityProduct.vue?vue&type=template&id=a6361fda"
import script from "./TemuOpportunityProduct.vue?vue&type=script&lang=js"
export * from "./TemuOpportunityProduct.vue?vue&type=script&lang=js"
import style0 from "./TemuOpportunityProduct.vue?vue&type=style&index=0&id=a6361fda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports